import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "routing-address-card" }
const _hoisted_2 = { class: "routing-address-card__header" }
const _hoisted_3 = { class: "routing-address-card__code typographies-paragraph-medium-semibold" }

import { inject } from 'vue';
import Card from 'vcomponents/common/card/Card.vue';
import { CardSize } from 'types/components/common/Card.type';
import type { Translator } from 'types/injects/translator.type';
import type { RoutingAddress } from 'types/entities/einvoicing/routingAddress.type';

interface Props {
    address: RoutingAddress;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RoutingAddressCard',
  props: {
    address: {}
  },
  emits: ["setDefault"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const $t = inject('$t') as Translator;
const translations: Record<string, string> = {
    activePill: $t.__('overview.tabs.TabRoutingAddresses.card.active_pill'),
    defaultAddress: $t.__('overview.tabs.TabRoutingAddresses.card.default_address'),
};

const onChange = (value: boolean): void => {
    // The switch is disabled when the address is the current default, so this callback only
    // fires when the user activates a non-default address (value === true).
    if (value) {
        emit('setDefault', props.address.id);
    }
};

return (_ctx: any,_cache: any) => {
  const _component_CompassTag = _resolveComponent("CompassTag")!
  const _component_CompassSwitch = _resolveComponent("CompassSwitch")!

  return (_openBlock(), _createBlock(Card, {
    size: _unref(CardSize).MEDIUM
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.address.code), 1 /* TEXT */),
          _createVNode(_component_CompassTag, {
            color: _ctx.CompassEnums.TagColorType.GREEN,
            size: _ctx.CompassEnums.TagSize.SMALL
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(translations.activePill), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["color", "size"])
        ]),
        _createVNode(_component_CompassSwitch, {
          class: "routing-address-card__switch",
          modelValue: __props.address.isDefault,
          label: translations.defaultAddress,
          size: _ctx.CompassEnums.SwitchSize.MEDIUM,
          orientation: _ctx.CompassEnums.SwitchOrientation.LEFT,
          disabled: __props.address.isDefault,
          onChange: onChange
        }, null, 8 /* PROPS */, ["modelValue", "label", "size", "orientation", "disabled"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["size"]))
}
}

})